var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWriteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Iconly_Light-outline_Edit",
    "data-name": "Iconly/Light-outline/Edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Edit-2",
    "data-name": "Edit",
    d: "M10.471,17a.645.645,0,0,1-.089-1.285l.089-.006h6.871a.645.645,0,0,1,.09,1.285l-.09.006ZM.659,17a.658.658,0,0,1-.476-.2A.63.63,0,0,1,0,16.339L.1,12.4a2.866,2.866,0,0,1,.868-1.982L10.66.916a3.24,3.24,0,0,1,4.515,0l1.294,1.269a3.087,3.087,0,0,1,0,4.427L6.741,16.149a2.98,2.98,0,0,1-2.1.851ZM1.9,11.328a1.6,1.6,0,0,0-.482,1.1l-.084,3.278H4.643A1.673,1.673,0,0,0,5.7,15.331l.107-.1,8.045-7.887L9.907,3.48ZM14.786,6.436l.752-.737a1.814,1.814,0,0,0,0-2.6l-1.3-1.269a1.9,1.9,0,0,0-2.653,0l-.752.737Z",
    fill: "#c4c4c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteIcon);
export default __webpack_public_path__ + "static/media/WriteIcon.6b311e83865f8c76a22dc25446ccee59.svg";
export { ForwardRef as ReactComponent };